import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from './views/Dashboard/Dashboard';
import Reviews from './views/Monitoring/Reviews/Reviews';
import Keywords from './views/Monitoring/Keywords/Keywords';
import Benchmarking from './views/Research/Benchmarking/Benchmarking';
import Locations from './views/GoogleMyBusiness/Locations/Locations';
import { default as GoogleMyBusinessReviews } from './views/GoogleMyBusiness/Reviews/Reviews';
import Evaluation from './views/GoogleMyBusiness/Evaluation/Evaluation';
import Commentings from './views/CommunityManagement/Commentings/Commentings';
import Administration from './views/Administration/Administration';
import Platforms from './views/Monitoring/Platforms/Platforms';
import Login from './views/Login/Login';
import ReviewMonitoringGuide from './views/Monitoring/Reviews/ReviewMonitoringGuide/ReviewMonitoringGuide';
import KeywordMonitoringGuide from './views/Monitoring/Keywords/KeywordMonitoringGuide/KeywordMonitoringGuide';
import EditMonitoring from './views/Monitoring/Reviews/EditMonitoring/EditMonitoring';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AICommentGenerator from './views/CommunityManagement/AICommentGenerator/AICommentGenerator';
import Trustpages from './views/Visibility/Trustpages/Trustpages';
import Trustpage from './views/Trustpage/Trustpage';
import NetPromoterScorePage from './views/NetPromoterScore/NetPromoterScorePage';
import ForgotPassword from './views/Login/ForgotPassword';
import ResetPassword from './views/Login/ResetPassword';
import SuccessPage from './views/Login/SuccessPage';
import LocationHistory from './views/GoogleMyBusiness/LocationHistory/LocationHistory';
import Surveys from './views/Research/SurveyTool/Surveys';
import TrustpageGuide from './views/Visibility/Trustpages/TrustpageGuide/TrustpageGuide';
import GMBAuthProvider from './providers/GMBAuthProvider';
import MoodBarometerPage from './views/MoodBarometer/MoodBarometerPage';
import StandardSurveyPage from './views/StandardSurvey/StandardSurveyPage';
import SurveyQuestions from './views/Research/SurveyTool/SurveyQuestions';
import CustomSurveyPage from './views/CustomSurvey/CustomSurveyPage';
import { useContext } from 'react';
import { AuthContext } from './providers/AuthProvider';
import AiReview from './views/Monitoring/Platforms/AiReview';

const App = () => {
  const { hasRole } = useContext(AuthContext);
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <Navigate
              replace
              to={hasRole('can-use-dashboard') ? '/dashboard' : '/monitoring/platforms'}
            />
          </ProtectedRoute>
        }
      />
      <Route
        path="/login"
        element={<Login />}
      />
      <Route
        path="/login/forgot-password"
        element={<ForgotPassword />}
      />
      <Route
        path="/login/reset-password"
        element={<ResetPassword />}
      />
      <Route
        path="/login/forgot-password/success"
        element={<SuccessPage />}
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/platforms"
        element={
          <ProtectedRoute>
            <Platforms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/reviews"
        element={
          <ProtectedRoute>
            <Reviews />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/keywords"
        element={
          <ProtectedRoute>
            <Keywords />
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/locations"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <Locations />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/reviews"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <GoogleMyBusinessReviews />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/location-history"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <LocationHistory />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/googlemybusiness/evaluation"
        element={
          <ProtectedRoute>
            <Evaluation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/benchmarking"
        element={
          <ProtectedRoute>
            <Benchmarking />
          </ProtectedRoute>
        }
      />
      <Route
        path="/communitymanagement/commentings"
        element={
          <ProtectedRoute>
            <Commentings />
          </ProtectedRoute>
        }
      />
      <Route
        path="communitymanagement/ai-commentgenerator"
        element={
          <ProtectedRoute>
            <AICommentGenerator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/surveytool/guide"
        element={
          <ProtectedRoute>
            <Surveys />
          </ProtectedRoute>
        }
      />
      <Route
        path="/research/surveytool/questions/:id"
        element={
          <ProtectedRoute>
            <SurveyQuestions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visibility/trustpages"
        element={
          <ProtectedRoute>
            <Trustpages />
          </ProtectedRoute>
        }
      />
      <Route
        path="/visibility/trustpages/guide"
        element={
          <ProtectedRoute>
            <TrustpageGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration"
        element={
          <ProtectedRoute>
            <GMBAuthProvider>
              <Administration />
            </GMBAuthProvider>
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/reviews/guide"
        element={
          <ProtectedRoute>
            <ReviewMonitoringGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/platforms/guide"
        element={
          <ProtectedRoute>
            <ReviewMonitoringGuide />
          </ProtectedRoute>
        }
      />

      <Route
        path="/monitoring/platform/:id/ai"
        element={
          <ProtectedRoute>
            <AiReview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/keywords/guide"
        element={
          <ProtectedRoute>
            <KeywordMonitoringGuide />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/reviews/edit"
        element={
          <ProtectedRoute>
            <EditMonitoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monitoring/platforms/edit"
        element={
          <ProtectedRoute>
            <EditMonitoring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trustpages/:id"
        element={<Trustpage />}
      />
      {/*Survey Tool routes start*/}
      <Route
        path="n/:id"
        element={<NetPromoterScorePage />}
      />
      <Route
        path="b/:id"
        element={<MoodBarometerPage />}
      />
      <Route
        path="s/:id"
        element={<StandardSurveyPage />}
      />
      <Route
        path="c/:id"
        element={<CustomSurveyPage />}
      />
      <Route
        path="/research/surveytool/guide/nps/:id"
        element={<NetPromoterScorePage />}
      />
      <Route
        path="/research/surveytool/guide/barometer/:id"
        element={<MoodBarometerPage />}
      />
      <Route
        path="/research/surveytool/guide/standard/:id"
        element={<StandardSurveyPage />}
      />
      {/*Survey Tool routes end*/}
    </Routes>
  );
};

export default App;
